import { render, staticRenderFns } from "./paginationComponent.vue?vue&type=template&id=b7a236c6"
import script from "./paginationComponent.ts?vue&type=script&lang=js&external"
export * from "./paginationComponent.ts?vue&type=script&lang=js&external"
import style0 from "./paginationComponent.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports